const QuoteStep = {
  TQ1: "tq1",
  TQ2: "tq2",
  TQ3: "tq3",
  TQ4: "tq4",
  TQ5: "tq5",
  TQ6: "tq6",
  TQ_ADD_DRIVER: "tqAddDriver",
  TQ_CLAIM: "tqClaim",
  TQ_PANEL: "TQ_PANEL",
  TQ_PANEL_LOADER: "tqPanelLoader",
};

export default QuoteStep;
